import React from 'react';
import { useNavigate } from 'react-router-dom';

export const QuizReResults = ({ score, questions, quizId }) => {
  const navigate = useNavigate();

  return (
    <div className="results-section">
      <h2>Re-Mock Test Completed!</h2>

      <h3>
        Your Score: {score} / {questions.length * 4}
        <span className="score-percentage">
          ({Math.round((score * 100) / (questions.length * 4))}%)
        </span>
      </h3>

      <button onClick={() => navigate(-2)} style={{ background: "blue", padding: "10px", borderRadius: "10px" }} >
        Show Questions and Answers ➨
      </button>


    </div>
  );
};